import styled from 'styled-components';
import { breakpoint } from '../../../../../admin/javascript/contract/duck/grid';

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: calc(100% - 20px);
  margin: 0 auto;
  padding: 10px;
  color: #333;
  font-size: 11px;
  background-color: #eee;

  > strong {
    font-weight: 600;
    font-size: 14px;
  }

  > span {
    margin-top: 3px;
  }

  ${breakpoint.m`
    width: calc(100% - 40px);
    margin: 0 20px;
    padding: 10px 20px;

    > strong {
      font-size: 16px;
    }
  `};
`;

export const SectionSubheader = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  padding: 10px 20px 5px 20px;
  color: #333333;
  font-size: 12px;
  line-height: 1.38;

  ${breakpoint.m`
    width: calc(100% - 40px);
    margin: 0 20px;
    font-size: 13px;
  `};
`;

export const ContinueButton = styled.button`
  float: right;
  min-width: 155px;
  height: 50px;
  padding: 0px 20px;

  color: #fff;
  font-weight: 600;
  font-size: 15px;
  line-height: 50px;
  text-align: center;
  text-transform: uppercase;
  background-color: ${({ disabled }) => (disabled ? '#efefef' : '#ffb43c')};

  border: solid 1px ${({ disabled }) => (disabled ? '#efefef' : '#ffb43c')};
  cursor: pointer;

  ${breakpoint.m`
    min-width: 250px;
    margin: 0 20px 20px 0;
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-top: 60px;
  padding: 0 10px 20px 10px;
  width: 100%;

  ${breakpoint.xs`
    padding: 0 20px 20px 20px;
  `};
  ${breakpoint.m`
    padding: 0;
  `};
`;



// WEBPACK FOOTER //
// ./app/javascript/pages/reservation/default/styled-components.jsx